// 권한을 permissionGroup 별로 묶는 유틸 (체크박스 그리드용)

import type { Permission } from "../types/permission.types";
import {
  getPermissionGroupLabel,
  PERMISSION_GROUP_ORDER,
} from "../constants/permission.constants";

export interface PermissionGroupBucket {
  groupCode: string;
  groupLabel: string;
  permissions: Permission[];
}

/**
 * 권한 배열을 permissionGroup으로 묶어서 반환
 * - 그룹 내 권한은 code 사전순 정렬
 * - 그룹 순서: PERMISSION_GROUP_ORDER 우선, 없는 그룹은 입력 순서로 뒤에
 */
export function groupPermissions(
  permissions: Permission[],
): PermissionGroupBucket[] {
  const insertionOrder: string[] = [];
  const map = new Map<string, Permission[]>();

  for (const p of permissions) {
    const key = p.permissionGroup || "etc";
    if (!map.has(key)) {
      insertionOrder.push(key);
      map.set(key, []);
    }
    map.get(key)!.push(p);
  }

  const orderRank = new Map(PERMISSION_GROUP_ORDER.map((g, i) => [g, i]));
  const sortedKeys = insertionOrder.slice().sort((a, b) => {
    const ra = orderRank.has(a) ? orderRank.get(a)! : Number.MAX_SAFE_INTEGER;
    const rb = orderRank.has(b) ? orderRank.get(b)! : Number.MAX_SAFE_INTEGER;
    if (ra !== rb) return ra - rb;
    return insertionOrder.indexOf(a) - insertionOrder.indexOf(b);
  });

  return sortedKeys.map((groupCode) => ({
    groupCode,
    groupLabel: getPermissionGroupLabel(groupCode),
    permissions: map
      .get(groupCode)!
      .slice()
      .sort((a, b) => a.code.localeCompare(b.code)),
  }));
}
